import { UserType } from 'pages/Account/types/user';
import { RootState } from 'internal/rootReducer';

export const selectUser = (state: RootState): UserType | null => state.userState.user;
